import axios from 'axios';

/**
 * Domain identifier used in API routes that are scoped by domain.
 * REACT_APP_* values are embedded at build time by Create React App.
 */
export const apiDomain = process.env.REACT_APP_DOMAIN ?? 'ph';

/**
 * Configured Axios instance for the Form Server RESTful API.
 * The base URL is pulled from the REACT_APP_API_BASE_URL environment variable.
 */
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default apiClient;
